import Loader from "../components/common/Loader";

export default function Loading() {
	return <Loader />;
}
